module.exports = __webpack_public_path__ + "static/media/instagram.b89981d4.svg";